<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <!-- <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col> -->
            <!-- <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col> -->
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.to"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" link :to="item.to">
            <v-list-item-action>
              <v-icon color="blue darken-2">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <!-- <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                large
                href="http://www.flyparaglider.com/"
                target="_blank"
                v-on="on"
                text
              >
                <v-icon color="green">mdi-earth</v-icon>
              </v-btn>
            </template>
            <span>Flyparaglider.com</span>
          </v-tooltip> -->
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">PG Box</span>
        <span style="padding-left: 12px">
          <v-avatar size="32px" item class="justify space-around">
            <v-img src="./assets/pg_logo_blue.png" alt="PB Box" /> </v-avatar
        ></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" v-if="!loggedIn" to="/login"
        >Log In<v-icon>mdi-login</v-icon></v-btn
      >
      
      <v-menu offset-y rounded="lg">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on" v-if="loggedIn">{{ cookiePgName }}
            <v-icon>mdi-account</v-icon><v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item to="/getprofile">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>My page</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-btn @click="logOut"
                ><v-icon left> mdi-logout </v-icon> Log Out</v-btn
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  props: {
    source: String,
  },
  data: () => ({
    menuoffset: true,
    dialog: false,
    drawer: null,
    items: [
      { icon: "mdi-home-outline", text: "Home", to: "/" },

      { icon: "mdi-view-list-outline", text: "Boxes", to: "/boxlist" },
      { icon: "mdi-login-variant", text: "Box Sign In", to: "/checkin" },
      { icon: "mdi-paragliding", text: "Pilots", to: "/airbox/0" },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Map",
        model: false,
        children: [
          // { icon: "mdi-view-list-outline", text: "Boxes", to: "/boxlist" },
          { icon: "mdi-map", text: "Box Map", to: "/airboxmap/0" },
          { icon: "mdi-layers-triple", text: "Air space", to: "/airspace" },
        ],
      },

      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Account",
        model: false,
        children: [
          // { icon: "mdi-key-outline", text: "Log In/Out", to: "/login" },
          {
            icon: "mdi-account-cog-outline",
            text: "My Account",
            to: "/getprofile",
          },
          {
            icon: "mdi-head-question-outline",
            text: "Forgot Access Code",
            to: "/sendac",
          },

          {
            icon: "mdi-account-plus-outline",
            text: "New user",
            to: "/newuser",
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Admin",
        model: false,
        children: [
          {
            icon: "mdi-lock-open-plus",
            text: "Box Open/Close",
            to: "/boxopenclose",
          },
          { icon: "mdi-account-cog", text: "Box Admin", to: "/boxadmin" },
          { icon: "mdi-account-cog", text: "Event Admin", to: "/happadmin" },
          {
            icon: "mdi-message-settings-outline",
            text: "Notification Service",
            to: "/adminnotificationstatus",
          },
        ],
      },
      { icon: "mdi-view-list-outline", text: "Events", to: "/eventlist" },

      { icon: "mdi-help-circle-outline", text: "Help", to: "/help/0" },
      { icon: "mdi-information-outline", text: "About", to: "/about" },
      // { icon: "mdi-help-circle", text: "DEVTEST", to: "/devtest" },
    ],
    loggedIn: false,
    cookieRegId: Number,
    cookieToken: Number,
    cookiePgName: String,
    regid: Number,
    key: 0,
  }),
  created() {
    this.getCookies();
  },
  methods: {
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePgName = this.$cookies.get("pgbname");
      this.regid = this.cookieRegId;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    resetCookies() {
      this.$cookies.set("pgbtoken", 0);
      this.$cookies.set("pgbregid", 0);
      this.$cookies.set("pgbname", "");
      this.loggedIn = false;
      this.getCookies();
    },
    logOut() {
      this.resetCookies();
      this.getCookies();
      // this.isAlertVisible = false;
      this.key++;
    },
  },
};
</script>